import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";

import Multiselect from "../multiselect/multiselect";
import AddressMultiselect from "../multiselect/addressMultiselect/addressMultiselect";
import DeliveryDayMultiselect from "../multiselect/deliveryDayMultiselect/deliveryDayMultiselect";

import { getCityZoneByCityZoneId } from "@/plugins/address_helper";
import {
  getNextDeliveryDateByCreationWeekDay,
  getAvailableSchedulesByCityZone,
} from "@/plugins/schedules_helper";

@Component({
  components: {
    Multiselect,
    AddressMultiselect,
    DeliveryDayMultiselect,
  },
  methods: {
    getNextDeliveryDateByCreationWeekDay,
  },
})
export default class AddressSchedulePicker extends Vue {
  @Prop({ default: null }) selectedAddress;
  @Prop({ default: null }) selectedCreationWeekDay;
  @Prop({ default: null }) selectedProgramSchedule;

  @Getter getUser;
  @Getter getSubscription;
  @Getter getCity;

  currentCityZone = null;
  extendedProgramSchedule = "05:30 PM - 08:00 PM";

  get getAvailableSchedules() {
    return getAvailableSchedulesByCityZone(
      this.currentCityZone,
      this.selectedCreationWeekDay,
      this.extendedProgramSchedule
    );
  }

  mounted() {
    this.onSelectAddress(this.selectedAddress);
    this.onSelectedAddressChange();
  }

  onSelectAddress(newAddress: any) {
    this.$emit("set-address", newAddress);
  }

  @Watch("selectedCreationWeekDay")
  onCreationWeekDayChange() {
    if (
      this.selectedCreationWeekDay.creation_week_day !== 1 &&
      this.selectedProgramSchedule === this.extendedProgramSchedule
    ) {
      this.$emit("set-program-schedule", this.getAvailableSchedules[0]);
    }
  }

  @Watch("selectedAddress")
  onSelectedAddressChange() {
    this.currentCityZone = getCityZoneByCityZoneId(this.getCity, this.selectedAddress.zone_id);
  }
}
